module.exports = __webpack_public_path__ + "img/logo.fd7200c1.png";